import { caUtils } from '@mca/contentapi-js';
import { toMilliSeconds } from '../services/seek';
import { getInstanceSettings, getKeyValues } from '../services/config';
import { getToken } from '../services/gvp';

/**
 * Playable media model
 *
 * @export
 * @param {Object} response Uniapi response
 * @returns {Object} Playable media.
 */
export function playableMedia({ Url, LA_URL, CustomData }) {
  return {
    url: Url,
    drmLicenseServerUrl: LA_URL || getKeyValues().widevineUrl,
    customData: CustomData || getToken()
  };
}

/**
 * LiveSchedule model.
 *
 * @param {Object} response ContentAPI response.
 * @returns {Object} Live schedule.
 */
export function liveSchedule(response) {
  const { age, title } = getAgeRating(caUtils.getId(response.AgeRatingPid));
  return {
    pid: response.Pid,
    title: response.Title,
    start: toMilliSeconds(response.Start),
    end: toMilliSeconds(response.End),
    blackoutAreas: response.Attributes.ca_blackout_areas,
    blackoutTargets: response.Attributes.ca_blackout_target,
    forbiddenTechnology: response.ForbiddenTechnology,
    ageRating: age ?? -1,
    ageTitle: title,
    image: {
      url: response.Images?.VideoFrame && response.Images.VideoFrame[0]?.Url,
      width: 163
    }
  };
}

/**
 * Obtains age rating from ID.
 *
 * @param {number} id ID of the age rating.
 * @return {number} Age rating value.
 */
function getAgeRating(id) {
  const ageRatings = getInstanceSettings().ageRatings;
  const age = ageRatings.length && ageRatings.filter((ageRating) => ageRating.ID === id)[0];
  return { age: age.Age, title: age.Title };
}
